import { WoltLogo, cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import HeaderContents from 'modules/logged-out-header/HeaderContents';

const Root = styled.div`
  position: relative;
  display: flex;
  height: 100px;
  padding: 10px 24px;
  width: 100%;
  justify-content: space-between;
  overflow: hidden;
`;

const StyledWoltLogo = styled(WoltLogo)`
  height: 30px;
  fill: ${cbSemanticCssVars.textPrimary};
`;

const SimpleHeader = () => {
  return (
    <Root>
      <StyledWoltLogo />
      <HeaderContents />
    </Root>
  );
};

export default SimpleHeader;
